import data from "@emoji-mart/data";

const STORAGE_KEY = "muzone.favoriteEmojis.v1";
const EMOJI_MART_FREQUENT = "emoji-mart.frequently";

function codepointToNative(unified) {
  if (!unified || typeof unified !== "string") return null;
  try {
    return unified
      .split("-")
      .map((cp) => String.fromCodePoint(parseInt(cp, 16)))
      .join("");
  } catch (_) {
    return null;
  }
}

// Build an id->native lookup from emoji-mart data (best-effort)
const idToNative = (() => {
  const map = new Map();
  try {
    const source = (data && (data.emojis || data)) || {};
    Object.keys(source).forEach((id) => {
      const entry = source[id];
      const skins = entry?.skins || [];
      const native = skins[0]?.native || codepointToNative(skins[0]?.unified);
      if (native) {
        map.set(id, native);
      }
    });
  } catch (_) {
    // ignore dataset issues
  }
  return (ident) => {
    const key = String(ident || "").replace(/:/g, "");
    return map.get(key) || null;
  };
})();

export function getFavoriteEmojis(defaults = ["✅", "👀", "🙌"]) {
  try {
    // Prefer emoji-mart's own recents if available
    const martRaw = localStorage.getItem(EMOJI_MART_FREQUENT);
    if (martRaw) {
      const mart = JSON.parse(martRaw);
      // emoji-mart stores an object of {"<emoji-id>": count}
      if (mart && typeof mart === "object") {
        const entries = Object.entries(mart)
          .filter(([key]) => key !== "_last" && key !== "_persist" && key !== "" );
        if (entries.length) {
          const top = entries
            .sort((a, b) => (b[1] || 0) - (a[1] || 0))
            .slice(0, 3)
            .map(([id]) => idToNative(id) || `:${id}:`);
          const natives = top.filter((e) => typeof e === "string" && /\p{Extended_Pictographic}/u.test(e));
          if (natives.length) return natives;
        }
      }
    }
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaults;
    const arr = JSON.parse(raw);
    if (Array.isArray(arr) && arr.length) return arr.slice(0, 3);
  } catch (_) {
    // ignore parsing/storage errors
  }
  return defaults;
}

export function bumpFavoriteEmoji(emoji) {
  if (!emoji || typeof emoji !== "string") return;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const arr = Array.isArray(JSON.parse(raw)) ? JSON.parse(raw) : [];
    const existing = arr.filter((e) => e !== emoji);
    const next = [emoji, ...existing].slice(0, 6);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (_) {
    // ignore
  }
}


